module.exports = __webpack_public_path__ + "static/media/ToyotaLogo.1942c154.jpg";